import { DASHBOARD_I18N_KEYS } from '../../../../../features/home/components/constants/i18n/Dashboardi18nConstants';

export const DASHBOARD_I18N_EN =  {
  [DASHBOARD_I18N_KEYS.overview]:  "Overview",
  [DASHBOARD_I18N_KEYS.add_chart]: "Add Chart",
  [DASHBOARD_I18N_KEYS.posts]:     "Posts",
  [DASHBOARD_I18N_KEYS.comments]:  "Comments",
  [DASHBOARD_I18N_KEYS.tweets]:    "Tweets",
  [DASHBOARD_I18N_KEYS.headlines]: "Headlines",
  [DASHBOARD_I18N_KEYS.data_compliance_agreement]: "" +
      "<p style='text-align: left;'>" +
    "1. By accessing the data and information provided in this dashboard and the “csv download” feature, " +
    "you are accepting and agreeing to be bound by these terms, which you acknowledge and agree that you " +
    "have read. You agree to be fully responsible for any consequences flowing from your non-compliance " +
    "with these terms." +
    "</p><br/>" +
    "<p style='text-align: left;'>" +
    "2. Data in this document is from the Facebook application programming interface (API), " +
    "specifically posts and comments from public Facebook pages, and is obtained under and subject " +
    "to Facebook’s terms in respect of such data. You must read and familiarise yourself with Facebook’s " +
    "terms before you use the data, and use the data consistently with Facebook’s terms at all times. " +
    "Links to Facebook’s terms (including its Data Policy, Data Use terms under Facebook Platform Terms " +
    "and so on) are available here: " +
    "<a href='https://www.facebook.com/legal/terms' style='color:#007bff;' target='_blank'>https://www.facebook.com/legal/terms</a>." +
    "</p><br/>" +
  "<p style='text-align: left;'>" +
    "3. Data in this document is also from the YouTube application programming interface (API), " +
    "specifically video info and comments from public YouTube channels, and is obtained under and subject " +
    "to YouTube’s terms in respect of such data. You must read and familiarise yourself with YouTube’s " +
    "terms before you use the data, and use the data consistently with YouTube’s terms at all times. " +
    "Links to YouTube’s terms (including its Data Policy, Data Use terms under YouTube Platform Terms " +
    "and so on) are available here: " +
    "<a href='https://developers.google.com/youtube/terms/developer-policies' style='color:#007bff;' target='_blank'>https://developers.google.com/youtube/terms/developer-policies</a>." +
    "</p><br/>" +
    "<p style='text-align: left;'>" +
    "4. The data should be used by you solely for the purposes of our project under our Agreement " +
    "for Research Collaboration or Service Agreement. Please also limit access to such data to persons " +
    "within your team (please provide a list of authorized personnel) who are working on our project, " +
    "and do not redistribute or otherwise share the data without our permission." +
    "</p><br/>" +
    "<p style='text-align: left;'>" +
    "5. Unless otherwise specified, this data is provided “as-is” with no warranties or representations " +
    "from us, whether it is accurate, fit for a particular purpose, etc." +
    "</p><br/>",
    [DASHBOARD_I18N_KEYS.social_media_data]: "Social Media Data",
    [DASHBOARD_I18N_KEYS.uploaded_data]:     "Uploaded Data",
    [DASHBOARD_I18N_KEYS.total_data_points]: "Total Data Points: "
}


// WEBPACK FOOTER //
// ./src/locales/en/features/home/components/dashboard.i18n.en.js